'use strict';

module.exports = {
  create: 'create',
  edit: 'edit',
  delete: 'delete',
};
